import type { Destination } from '../../types';

/**
 * How a channel is named and ordered wherever a user picks one (SC-3146/3147/3148).
 *
 * Extracted because the paused suffix is USER-FACING COPY, and it was being
 * spelled out independently in the facet rail, the bulk dialog and the upload
 * picker. Three copies of a sentence fragment is three places to miss when the
 * wording changes.
 */

/**
 * The label for one channel. A paused channel is named as paused everywhere it
 * can be picked: an entity can belong to one, and a picker that hides the
 * distinction tells the user their choice will start syncing when it won't.
 */
export function channelLabel(d: Destination): string {
  return d.enabled ? d.name : `${d.name} · paused`;
}

/**
 * Enabled channels first, then alphabetical by name.
 *
 * A paused channel stays selectable — building an assortment before switch-on is
 * the point — it just shouldn't sit above the live ones.
 */
export function byStatusThenName(a: Destination, b: Destination): number {
  if (a.enabled !== b.enabled) return a.enabled ? -1 : 1;
  return a.name.localeCompare(b.name);
}

/** "a", "a and b", "a, b and c" — for naming channels in a sentence. */
export function joinNames(names: string[]): string {
  if (names.length <= 1) return names[0] ?? '';
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`;
}
